import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import { collectionObjectApiPath, normalizeCollectionObjectStats } from '@/utils/collection-object'

export default function useCollectionStats(collection_slug: string) {
	const key = collection_slug ? `${API_URL}/${collectionObjectApiPath(collection_slug)}/stats` : null
	return useSwr(key, async (url: string) =>
		normalizeCollectionObjectStats(await fetcher(url), collection_slug)
	)
}
